import {Draggable, gsap, InertiaPlugin} from "gsap/all";
import $ from "jquery";
import {DraggableScene} from "./DraggableScene";
import {DotLottie} from "@lottiefiles/dotlottie-web";

export class ContextualMenu {

  constructor({selector, onSelect}) {
    this.$el = $(selector);
    this.previousDraggable = null
    this.selectedType = null;
    this.onSelect = onSelect;

    this.isOpen = false;

    this.init();

    // Close contextual menu when it is open and that the event is triggered outside the contextual menu
    $(window).on('touchstart mousedown', (e) => {
      if (this.isOpen && (this.previousDraggable !== null && e.target !== this.previousDraggable.target) && $(e.target).parents(".contextual-molecule-selector").length === 0 && !$(e.target).hasClass("contextual-molecule-selector")) {
        this.close();
      }
    });

    // On choice selected
    this.$el.on("click", ".choice", (e) => {
      const molecule = $(e.currentTarget).data("molecule")
      this.select(molecule)
    })
  }

  init() {
  }

  open(draggable) {

    draggable.disable()
    gsap.killTweensOf(draggable.target);

    // Move to left if draggable is too much on right
    const showOnLeftSide = (draggable.x > 1460);
    this.$el.toggleClass("contextual-menu-left", showOnLeftSide);

    // Toggle choices options
    this.selectedType = $(draggable.target).data("type");
    this.$el.find(".choices").hide()
    this.$el.find(`.choices[data-for='${this.selectedType}']`).show()

    const tl = gsap.timeline();

    if (this.isOpen) tl.add(this.close(this.previousDraggable));

    tl.add(() => $(draggable.target).addClass("contextual-menu"));

    tl.set(this.$el, {
      x: Math.round(draggable.x) + 16,
      y: Math.round($(draggable.target).offset().top - this.$el.outerHeight() / 2) - 18,
      zIndex: 999,
    });

    tl.fromTo(this.$el, {
      autoAlpha: 0,
      scale: 0.9,
    }, {
      autoAlpha: 1,
      scale: 1,
      duration: 0.2,
      ease: "sine.out",
      immediateRender: false,
    });

    this.previousDraggable = draggable;
    this.isOpen = true;
  }

  close(previousDraggable = null) {
    previousDraggable = previousDraggable ?? this.previousDraggable;

    const tl = gsap.timeline();
    if (this.isOpen) {
      tl.to(this.$el, {
        autoAlpha: 0,
        scale: 0.9,
        duration: 0.2,
      });
    }

    if (previousDraggable && $(previousDraggable.target).data("locked-dropzone") === null) {
      tl.add(() => $(previousDraggable.target).removeClass("contextual-menu"));
      // Restore floating
      tl.add(() => {
        DraggableScene.floatElement(previousDraggable.target)
        previousDraggable.enable();
      });
    }

    this.previousDraggable = null;

    return tl;
  }

  select(molecule) {
    console.log("Molecule selected: " + molecule);

    const markAsExpanded = function (e) {
      $(lottie.canvas).parent().addClass("expanded-loaded")
      lottie.removeEventListener("render", markAsExpanded)
    }.bind(this)

    // Remove current expanded content, if any
    ContextualMenu.removeLottieCanvas(this.previousDraggable)

    const canvas = $("<canvas width='160' height='160'></canvas>")
    $(this.previousDraggable.target).append(canvas);
    $(this.previousDraggable.target).addClass("expanded");

    // Trigger molecule animation
    const lottie = new DotLottie({
      canvas: canvas.get(0),
      src: `animations/etoiles/ZONE1_ME_MNS2_INT1_AMAS_${this.selectedType.toUpperCase()}_sans_V2.json`,
      loop: false,
      autoplay: true,
      renderConfig: {devicePixelRatio: 1},
    });
    lottie.addEventListener("render", markAsExpanded);
    lottie.play();
    canvas.data("lottie", lottie);

    this.close()

    if (this.onSelect) {
      this.onSelect(molecule, $(lottie.canvas).parent());
    }
  }

  static removeLottieCanvas(draggable) {
    const canvas = $(draggable.target).find("canvas")
    if (canvas.length > 0) {
      const lottie = canvas.data("lottie");
      if (lottie) {
        canvas.data("lottie", null);
        lottie.destroy();
      }
      canvas.remove();
    }
    $(draggable.target).removeClass("expanded expanded-loaded")
  }

  reset() {
    this.close();
    this.selectedType = null;
    this.previousDraggable = null;
  }
}

